import Grid from '@mui/material/Grid2';
import React, { useEffect, useState } from 'react';

import ButtonComponent from '#app/Component/ButtonComponent';
import SelectComponent from '#app/Component/SelectComponent';
import TextFieldComponent from '#app/Component/TextFieldComponent';
import { Form, initFormHandler } from '#app/Handler/FormHandler';
import { Payload } from '#app/View/Sale/OrderClient/SaleOrderClient/components/DisputeModal';
import { OrderDocument } from '#app/typings/orderDocument';

type Props = {
  documents: OrderDocument[];
  onClose: () => void;
  loading: boolean;
  onSubmit: (payload: Payload) => void;
};

const DisputeInvoice: React.FC<Props> = ({ documents, onClose, loading, onSubmit }) => {
  const [form, setForm] = useState<Form>({
    reason: {
      name: 'reason',
      label: 'Raison',
      textHelper: 'Saisissez une raison.',
      type: 'text',
    },
    ...(documents.length > 1 && {
      orderDocument: {
        name: 'orderDocument',
        label: 'Facture',
        textHelper: 'Selectionnez la facture en litige.',
        type: 'integer',
        options: { validation: ['required'] },
      },
    }),
  });

  const handlerForm = initFormHandler(form, setForm);

  useEffect(() => {
    handlerForm.start();
  }, []);

  const handleSubmit = (): void => {
    if (handlerForm.checkError() < 1) {
      handlerForm.setFormLoading(true);
      const data = handlerForm.getData();

      onSubmit({
        reason: data.reason,
        orderDocument: (data.orderDocument ?? documents[0].id) as number,
      });
    }
  };

  return (
    <>
      <Grid size={12}>
        <TextFieldComponent id="reason" handler={handlerForm} multiline />
      </Grid>
      {documents.length > 1 && (
        <Grid size={12}>
          <SelectComponent
            id="orderDocument"
            options={documents.map((document) => ({
              value: document.id,
              label: document.reference,
            }))}
            handler={handlerForm}
          />
        </Grid>
      )}

      <Grid size={12} container spacing={2} justifyContent="end">
        <ButtonComponent color="#5E6E82" label="Annuler" onClick={onClose} loading={loading} />
        <ButtonComponent label="Enregistrer" onClick={handleSubmit} loading={loading} />
      </Grid>
    </>
  );
};

export default DisputeInvoice;
